import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { providerApiClient } from '@/lib/api'
import { onboardingKeys } from '@/lib/queryKeys'
import type { OnboardingProgress } from '@/types/onboarding'

export function useOnboardingProgress() {
  return useQuery({
    queryKey: onboardingKeys.progress(),
    queryFn: () => providerApiClient.getOnboardingProgress(),
    staleTime: 60 * 1000,
  })
}

export function useUpdateOnboardingProgress() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: OnboardingProgress) => providerApiClient.updateOnboardingProgress(data),
    onSuccess: (updated) => {
      queryClient.setQueryData(onboardingKeys.progress(), updated)
    },
  })
}

// Caller is responsible for refreshing auth state (refreshProvider) after
// completion — auth state lives in React state, not TanStack Query.
export function useCompleteOnboarding() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => providerApiClient.completeOnboarding(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingKeys.progress() })
    },
  })
}
